  import React, { useContext, useEffect, useState } from 'react';
  import { Button } from 'antd';
  import { LeftOutlined, RightOutlined } from '@ant-design/icons';
  import { useNavigate } from 'react-router-dom';
  import axios from 'axios';
  import { GlobalContainerContext } from '../../../components/privateroute';

  const NavigationButtons = ({ sprawaId }) => {
    const [prevSprawa, setPrevSprawa] = useState(null);
    const [nextSprawa, setNextSprawa] = useState(null);
    const [isFirst, setIsFirst] = useState(false);
    const [isLast, setIsLast] = useState(false);
    const [isInList, setIsInList] = useState(false);
    const { globalContainer } = useContext(GlobalContainerContext);
    const navigate = useNavigate();
    useEffect(() => {
      const fetchWatchedSprawy = async () => {
        console.log('WATCHED', globalContainer)
        if (globalContainer?.selectedList?.includes('watched')) {
            console.log('WATCHED', globalContainer)
          try {
            const response = await axios.post('/sprawy/list/posts/watched', {});
            console.log(response.data)
            const sprawy = response.data.rows;
            const currentIndex = sprawy.findIndex(sprawa => sprawa.ticketid === sprawaId);

            if (currentIndex === -1) {
              setIsInList(false);
              return;
            }

            setIsInList(true);
            setIsFirst(currentIndex === 0);
            setIsLast(currentIndex === sprawy.length - 1);

            if (currentIndex > 0) {
              setPrevSprawa(sprawy[currentIndex - 1].ticketid);
            }

            if (currentIndex < sprawy.length - 1) {
              setNextSprawa(sprawy[currentIndex + 1].ticketid);
            }
          } catch (error) {
            console.error('Error fetching watched sprawy:', error);
          }
        }
      };

      fetchWatchedSprawy();
    }, [sprawaId, globalContainer]);

    const handleNavigation = (id) => {
      navigate(`/sprawy/${id}`);
    };

    return (
      isInList && (
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', margin: '20px 0' , justifyContent: 'space-between' }}>
          <div>{prevSprawa && !isFirst && (
            <Button 
              type="default"
              icon={<LeftOutlined />}
              onClick={() => handleNavigation(prevSprawa)}
            >
              Poprzednia obserwowa sprawa
            </Button>
          )}
          </div>
          <div>{nextSprawa && !isLast && (
            <Button 
              type="default"
              icon={<RightOutlined />}
              onClick={() => handleNavigation(nextSprawa)}
            >
              Następna obserwowa sprawa
            </Button>
          )}
          </div>
        </div>
      )
    );
  };

  export default NavigationButtons;
